import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { fontSizes } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Font Sizes' />

# Font Sizes

<TokensGrid tokens={fontSizes} hasRemValue />
